/**
 * Candidate (Aday) schemas — Spec Bölüm 4.5.3
 */
import { z } from 'zod';
import { CuidSchema, ExperienceBandSchema, PasswordSchema } from './common.js';

// ─── Aday kayıt — sınav öncesi (Spec 7.2) ────────────────────────
// Anonim modda fullName/email yerine anonymousId zorunlu
export const CandidateRegisterSchema = z
  .object({
    accessCode: z.string().regex(/^[A-Z0-9]{2,10}-[A-Z0-9]{4}$/, 'Geçersiz erişim kodu'),
    fullName: z.string().min(2).max(100).optional(),
    email: z.string().email().optional(),
    anonymousId: z.string().min(3).max(50).optional(), // "ADAY-001"
    position: z.string().max(150).optional(),
    experienceYears: ExperienceBandSchema,
    publicCertConsent: z.boolean().default(false),
    kvkkAydinlatmaAccept: z.literal(true),
    kvkkAiIslemeAccept: z.literal(true),
  })
  .refine(
    (data) => {
      // Anonim mod: anonymousId şart, kişisel veri yasak
      // Normal mod: fullName + email şart, anonymousId yasak
      const isAnon = !!data.anonymousId;
      if (isAnon) return !data.fullName && !data.email;
      return !!data.fullName && !!data.email;
    },
    {
      message:
        'Anonim modda anonymousId; normal modda fullName + email zorunlu. İki mod karıştırılamaz.',
    },
  );
export type CandidateRegisterInput = z.infer<typeof CandidateRegisterSchema>;

// ─── Aday profil update ──────────────────────────────────────────
export const UpdateCandidateProfileSchema = z.object({
  name: z.string().min(2).max(100).optional(),
  position: z.string().max(150).optional(),
  experienceYears: ExperienceBandSchema.optional(),
  publicCertConsent: z.boolean().optional(),
  marketingConsent: z.boolean().optional(),
});
export type UpdateCandidateProfileInput = z.infer<typeof UpdateCandidateProfileSchema>;

// ─── Sınav sonu hesap bağlama ────────────────────────────────────
// Aday önce sınava giriyor (kayıtsız), sonra hesap oluşturuyor.
// Yeni hesap → mevcut Candidate kayıtlarını bağla.
export const LinkAccountToCandidateSchema = z.object({
  candidateId: CuidSchema,
  /** Mevcut sınavda yaratılmış candidate'i hangi user'a bağlayacağız */
  verifyEmail: z.string().email(),
});
export type LinkAccountToCandidateInput = z.infer<typeof LinkAccountToCandidateSchema>;

// ─── Şifre değiştir ──────────────────────────────────────────────
export const ChangePasswordSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: PasswordSchema,
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;

// ─── Hesap kapatma ───────────────────────────────────────────────
export const DeactivateAccountSchema = z.object({
  password: z.string().min(1, 'Şifre onayı gerekli'),
  reason: z.string().max(500).optional(),
});
export type DeactivateAccountInput = z.infer<typeof DeactivateAccountSchema>;
